import { Box } from '@mui/material';
import React from 'react';
const gapInPixels = 8;
/**
 * Long list of inline blocks with ability to collapse to a single line. Shows number of hidden items. Can add actions
 * that appear at the end of blocks.
 */
export const LongListOfInlineBlocks = ({ collapseToSingleLine, renderActions, sx, children }) => {
    const ref = React.useRef(null);
    const [hiddenBlockCount, setHiddenBlockCount] = React.useState(0);
    const [moreThanOneLine, setMoreThanOneLine] = React.useState(false);
    const reflow = React.useCallback(() => {
        const div = ref.current;
        if (div) {
            const divRect = div.getBoundingClientRect();
            let actionsWidth = 0;
            const lastChild = div.children.length > 0 ? div.children[div.children.length - 1] : undefined;
            if ((lastChild === null || lastChild === void 0 ? void 0 : lastChild.dataset['actions']) === 'true') {
                actionsWidth = lastChild.getBoundingClientRect().width;
            }
            let xPosition = 0;
            let hiddenBlockCountVariable = 0;
            let moreThanOneLineVariable = false;
            for (const child of div.children) {
                if ((child === null || child === void 0 ? void 0 : child.dataset['actions']) === 'true') {
                    continue;
                }
                const childRect = child.getBoundingClientRect();
                xPosition += childRect.width;
                if (collapseToSingleLine) {
                    if (xPosition > divRect.width - actionsWidth) {
                        child.style.position = 'absolute';
                        child.style.visibility = 'hidden';
                        child.style.top = '0';
                        child.style.left = '0';
                        ++hiddenBlockCountVariable;
                        moreThanOneLineVariable = true;
                    }
                    else {
                        child.style.position = 'static';
                        child.style.visibility = 'visible';
                    }
                }
                else {
                    if (xPosition > divRect.width - actionsWidth) {
                        ++hiddenBlockCountVariable;
                        moreThanOneLineVariable = true;
                    }
                    child.style.position = 'static';
                    child.style.visibility = 'visible';
                }
                xPosition += gapInPixels;
            }
            setHiddenBlockCount(hiddenBlockCountVariable);
            setMoreThanOneLine(moreThanOneLineVariable);
        }
    }, [collapseToSingleLine]);
    React.useLayoutEffect(reflow);
    React.useEffect(() => {
        let resizeObserver;
        const div = ref.current;
        if (div) {
            resizeObserver = new ResizeObserver(() => {
                window.requestAnimationFrame(reflow);
            });
            resizeObserver.observe(div);
        }
        return () => {
            if (resizeObserver && div) {
                resizeObserver.unobserve(div);
            }
        };
    }, [reflow]);
    return (React.createElement(Box, { ref: ref, sx: [
            {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                gap: gapInPixels + 'px',
                flexWrap: collapseToSingleLine ? undefined : 'wrap',
                overflow: collapseToSingleLine ? 'hidden' : undefined,
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ] },
        children,
        renderActions && (React.createElement(Box, { "data-actions": 'true' }, renderActions({
            collapseToSingleLine: collapseToSingleLine || !moreThanOneLine,
            hiddenBlockCount,
        })))));
};
